export default {
  infoText:{
    textAlign:"center"
  },
  selectLabel:{
    fontSize:'15px',
    color: '#aaaab8'
  },
  submit:{
    marginTop:20,
    float:'right'
  },
  selectLabelMulti: {
    fontSize: "12px",
    textTransform: "uppercase",
    color: "#AAAAAA !important",
    position: 'inherit',
    top: "18px"
  },
}



// WEBPACK FOOTER //
// ./src/assets/jss/material-dashboard-pro-react/views/form.jsx